import type { CasAddressStored } from "./Address";

export type Gender = "male" | "female" | "prefer_not_to_say";

export type DateOfBirth = string | null;

export type Contact = {
  firstname: string;
  lastname: string;
  telephone: string;
  // NOTE: null will come if feature flag is enabled on the BE and undefined if feature flag is disabled
  gender?: Gender | null;
};

export type ContactPersonal = Contact & {
  dob: DateOfBirth;
  email: string;
};

export type ResponseProfileInfoType = Contact & {
  date_of_birth: DateOfBirth;
  phone: string;
  email: string;
};

export type NewsletterPreferences = {
  marketingEmailsEnabled: boolean;
};

export type TextMessagePreferences = {
  marketingSmsEnabled: boolean;
};

export type ExtraProfileField = {
  [key: string]: string | undefined;
  preferredLanguage?: string;
};

export type ProfileMeta = {
  allow_date_of_birth_update: boolean;
  allow_name_update?: boolean;
  is_age_verified?: boolean;
};

export type ResponseProfileType = {
  addresses: CasAddressStored[];
  personal_info: ResponseProfileInfoType;
  is_pending_email_verification: boolean;
  is_age_verified: boolean;
  extra: ExtraProfileField;
  purposes: string[];
  meta: ProfileMeta;
};

export type EvoConsumer = {
  uuid?: string;
  email?: string;
  phone?: string | null;
  first_name?: string;
  last_name?: string;
  created_at?: string | null;
  date_of_birth?: string | null;
  age_verification_uuid?: string | null;
  custom_attributes: Record<string, string | null | undefined>;
  gender?: string | null;
  referral_code?: string | null;
  addresses?: CasAddressStored[];
};

export type EvoProfileResponseType = {
  data: {
    consumer: EvoConsumer;
    is_pending_email_verification?: boolean;
    referrer_statistics?: {
      earned_points?: number;
      referrals_count?: number;
      completed_first_order_count?: number;
    };
    purposes?: Array<string>;
    has_registered_device?: boolean | null;
    referrals?: {
      can_enter_a_code?: boolean;
      can_receive_discount?: boolean;
    };
  };
  meta: ProfileMeta;
};

export type PreparedProfileType = {
  addresses?: CasAddressStored[];
  personalInfo: ContactPersonal;
  is_age_verified: boolean;
  is_pending_email_verification: boolean;
  extra: ExtraProfileField;
  purposes: string[];
  meta: ProfileMeta;
};

export type UpdateProfileInformationResponse = {
  personal_info: ResponseProfileInfoType;
};
